import React from 'react'

import { strings } from './users-content'
import styles from '../../styles/modules/users/users-query.module.scss'


interface Props {
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  email: string
}

const QueryEmail: React.FC<Props> = props => (
  <div className={styles.container}>
    <span className={styles.title}>{strings.queryEmailTitle}</span>
    <div className={styles.box}>
      <div className={styles.wrapper}>
        <input
          placeholder="メールアドレス"
          value={props.email || ''}
          onChange={props.onChange}
        />
      </div>
    </div>
  </div>
)

export default QueryEmail
